import { h } from "preact";
import { observer } from "mobx-react";
import CartItemPrice from "./CartItemPrice";
import CartItemDescription from "./CartItemDescription";
import CartPromotionItemSelect from "./CartPromotionItemSelect";
function CartPromotionItem(props) {
    const { promotion } = props;
    const { id, name, description, descriptionUrl, value, isActive: isChecked, isSelectable, isDisabled, effect, } = promotion;
    const isCheckboxVisible = isSelectable || isChecked;
    const isFreebieType = effect.type === "Freebie";
    const handleChange = (event) => {
        const checked = event.target.checked;
        promotion.setActive(checked);
    };
    return (h("li", { class: `item promotion ${isChecked ? "" : "off"} ${isDisabled ? "item--inactive" : ""}` },
        h("div", { class: "cart-multi-column mobile" },
            h("div", { class: "column column--checkbox" }, isCheckboxVisible && (
            // TODO: we want to apply `u-visibility-hidden` class when isDisabled?
            h("label", { class: "m-checkbox", "data-field-id": `Cart.promotions.${id}.enabled` },
                h("input", { type: "checkbox", checked: isChecked, disabled: isDisabled, onChange: handleChange, class: "promotion-enabled m-checkbox__input" }),
                h("i", { class: "m-checkbox__icon-state" })))),
            h("div", { class: "column info" },
                h("span", { class: "name" }, name),
                h(CartItemDescription, { text: description, url: descriptionUrl })),
            h("div", { class: "column column--price" },
                h(CartItemPrice, { price: value || "" }))),
        isFreebieType && promotion.isActive && (h("div", { class: "promotion-select" },
            h(CartPromotionItemSelect, { freebies: effect.freebies.raw, selectedValue: promotion.freebie, onSelect: (value) => promotion.setFreebie(value) })))));
}
export default observer(CartPromotionItem);
